<template>
  <v-dialog v-model="loading" persistent content-class="loading-dialog" width="300">
    <v-card color="primary" dark>
      <v-card-text>
        <span class="d-block font-weight-bold pt-2">
          {{ $t('globals.loading') }}
        </span>
        <v-progress-linear class="mt-3" indeterminate color="white" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LoadingDialog',
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>
